import api from '../../api/client';
import FeedReport from "./FeedReport.js";

const InventoryReport = () => {
  return (
    <div>
      <FeedReport />
    </div>
  );
};

export default InventoryReport;
